import { Optional } from "@/@types/utils.ts";

export enum EOSType {
  IOS = "IOS",
  MACOS = "MACOS",
  ANDROID = "ANDROID",
  WINDOWS = "WINDOWS",
  IPADOS = "IPADOS",
}

export enum EOsTypeEnum {
  ANDROID = "ANDROID",
  IOS = "IOS",
  MACOS = "MACOS",
  WINDOWS = "WINDOWS",
  IPADOS = "IPADOS",
  TVOS = "TVOS",
}

export type DeviceType = {
  id: string;
  name: string;
  battery: {
    createdAt: string;
    isCharging: boolean;
    level: number;
    updatedAt: string;
  };
  model: string;
  upTime?: string;
  deletedAt?: string;
  serialNumber: string;
  ownershipType: string;
  diskSize: number;
  displaySizes: string[];
  ram: GetDeviceListResponse_DeviceBasic_RamDetail | undefined;
  platform: string;
  os: OSType;
  isOnline: boolean;
  online: boolean;
  osName: string;
  osVersion: string;
  deliveryMethod: string;
  department?: { id: string; name: string };
  employee?: GetDeviceListResponse_DeviceBasic_EmployeeDevice;
  employeeId?: string;
  createdAt: string;
  updatedAt: string;
  retrievalType?: ERetrievalType;
  dataActionType?: EDataActionType;
  hardwareId: string;
  tags: TDeviceTagsResponse["tags"];
  enrollType?: string;
  metadata?: string;
  disconnectedAt?: string;
  deviceGroups?: TDeviceGroups[];
};

export type TDeviceTagsResponse = {
  tags: {
    id: string;
    companyId: string;
    name: string;
    color: string;
    createdAt: string;
    updatedAt: string;
    deviceCount: number;
    version: number;
  }[];
};

export enum EDataActionType {
  NOACTION = "NOACTION",
  CLEANDATA = "CLEANDATA",
}

export enum ERetrievalType {
  BACKOFFICE = "BACKOFFICE",
  NORETRIEVE = "NORETRIEVE",
}

export enum EDeviceOwnerShip {
  BYOD = "BYOD",
  COD_IN_OFFICE = "COD_IN_OFFICE",
  COD_OUT_OFFICE = "COD_OUT_OFFICE",
  CO = "CO",
}

export type TDeviceGroups = {
  id: string;
  companyId: string;
  name: string;
  description: string;
  osTypes: OSType;
  ownershipType: EDeviceOwnerShip[];
  createdAt: string;
  updatedAt: string;
  createdById: string;
};

export interface GetDeviceListResponse_DeviceBasic_EmployeeDevice {
  id: string;
  firstName: string;
  lastName: string;
  profile: string;
  email?: string;
  department?: GetDeviceListResponse_DeviceBasic_EmployeeDevice_DepartmentDevice;
}

export interface GetDeviceListResponse_DeviceBasic_EmployeeDevice_DepartmentDevice {
  id: string;
  name: string;
}

export type OSType =
  | "IPADOS"
  | "IOS"
  | "TVOS"
  | "MACOS"
  | "ANDROID"
  | "LINUX"
  | "WINDOWS";

export interface GetDeviceListResponse_DeviceBasic_RamDetail {
  maximumCapacity: number;
}

export type Reporter = {
  firstName: string;
  lastName: string;
  profile: string;
  id?: string;
};

export type TSort = "ASC" | "DESC";

export type JobTitle = {
  name: string;
  id: string;
};

export type EmployeeType = {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  accountStatus?: EAccountStatus;
  changePasswordStatus?: boolean;
  startDate?: string;
  homePhone?: string;
  homePostalCode?: string;
  personalEmail?: string;
  homePhoneIso?: string;
  phoneIso?: string;
  mobilePhone?: string;
  homeCountry?: string;
  homeAddress?: string;
  managerId?: string;
  managerName?: string;
  homeCity?: string;
  homeState?: string;
  birthDate?: string;
  profile?: string;
  reporter?: Reporter;
  contractType?: EContractType;
  jobTitle?: JobTitle;
  departmentId?: string;
  department?: {
    id: string;
    name: string;
  };
  office?: {
    id: string;
    name: string;
  };
  workType?: EWorkType;
  officeId?: string;

  role?: {
    id: string;
    name: string;
  };
  importedFrom?: EDomainType;
  employeeName?: string;
  sameManagedAppleId?: boolean;
};

export enum DeviceOs {
  IOS = "IOS",
  TVOS = "TVOS",
  MACOS = "MACOS",
  ANDROID = "ANDROID",
  WINDOWS = "WINDOWS",
  IPADOS = "IPADOS",
  LINUX = "LINUX",
}

export type TDeviceLogs = {
  id: string;
  companyId: string;
  correlationId: string;
  success: true;
  eventCategory: string;
  eventName: string;
  deviceId: string;
  deviceName: string;
  hardwareId: string;
  deviceOs: OSType;
  osName: string;
  osVersion: string;
  group: string;
  groupId: string;
  user: string;
  level: string;
  state: string;
  timestamp: string;
  description: string;
};

export enum EEventCategoryDevice {
  DEVICE_LOG_USER_MANAGEMENT = "DEVICE_LOG_USER_MANAGEMENT",
  NETWORK_AND_REMOTE_ACCESS = "NETWORK_AND_REMOTE_ACCESS",
  ENROLLMENT = "ENROLLMENT",
  HEALTH_PERFORMANCE = "HEALTH_PERFORMANCE",
  OPERATIONS = "OPERATIONS",
  SECURITY_COMPLIANCE = "SECURITY_COMPLIANCE",
  GEOFENCE = "GEOFENCE",
}

export type TGetDeviceLogsParams = {
  hardwareId?: string;
  eventCategory?: EEventCategoryDevice[];
  eventDescription?: string;
  level?: string[];
  state?: string[];
  deviceName?: string;
  eventName?: string;
  deviceId?: string;
  success?: boolean;
  fromDate?: string;
  toDate?: string;
  page: number;
  limit: number;
  orderBy?: "eventName" | "success" | "timestamp";
  orderDirection?: ESort;
};

export type TEmployeeSearchType = Optional<
  EmployeeType,
  "firstName" | "lastName"
> & {
  employeeName: string;
  companyId: string;
  managerId?: string;
  jobName?: string;
  departmentId?: string;
  officeCountry?: string;
  accountStatus: EAccountStatus;
  deletedAt?: string;
  itsMe?: boolean;
  createdAt: string;
  reporter?: {
    id: string;
    firstName: string;
    lastName: string;
    profile: string;
  };
  enrollCode: {
    id: string;
    isCompanyLinkEnable: boolean;
    status: string;
    type: string;
    value: string;
  };
  devices: DeviceType[];
  birthDate: string;
  contractType: string;
  displayName: string;
  importedFrom: string;
  lastlogin: string;
  mfaStatus: {
    status: string;
    mfaType?: MfaStatus;
  };
  passwordStatus: PasswordStatusEnum;
  userGroups: {
    id: string;
    name: string;
  }[];
};

export enum MfaStatus {
  NOT_SETUP = "NOT_SETUP",
  NOT_ENABLED = "NOT_ENABLED",
  ENABLED = "ENABLED",
}

export type TOneUserDetails = {
  alternativeEmail: string;
  birthDate: string;
  city: string;
  companyEmail: string;
  country: string;
  department: string;
  description: string;
  displayName: string;
  employeeId: string;
  enrollmentSource: string;
  firstName: string;
  jobTitle: string;
  lastLogin: string;
  lastName: string;
  manager: string;
  mfaAllowedMethods: string;
  mfaEnforce: boolean;
  mfaStatus: {
    status: string;
  };
  passwordStatus: PasswordStatusEnum;
  phoneNumber: string;
  postalCode: string;
  province: string;
  role: string;
  startDate: string;
  status: string;
  totpMfaExpiration: string;
  webAuthStatus: string;
  address: string;
  managerId: string;
  profile: string;
  roleId: string;
  uniqueId: string;
};

export type TSelectedUser = {
  id: string;
  accountStatus: EAccountStatus;
  email: string;
  employeeName: string;
};

export type TUserGroupType = {
  name: string;
  description: string;
  membershipControlType: "static" | "dynamic";
  userIds: string[];
  createdAt: string;
  id: string;
  members: { id: string; email: string }[];
  updatedAt: string;
};

export type EmployeeInfoType = {
  accountStatus: string;
  changePasswordStatus: boolean;
  email: string;
  firstName: string;
  id: string;
  lastName: string;
  mobilePhone: string;
  personalEmail: string;
};

export type TEmployeeMDMApps = {
  hardwareId: string;
  installedApplicationList: {
    adHocCodeSigned: boolean;
    appStoreVendable: boolean;
    betaApp: boolean;
    bundleSize: string;
    deviceBasedVpp: boolean;
    downloadCancelled: boolean;
    downloadFailed: boolean;
    downloadPaused: boolean;
    downloadWaiting: boolean;
    dynamicSize: string;
    deviceName?: string;
    externalVersionIdentifier: number;
    hasUpdateAvailable: boolean;
    identifier: string;
    installing: boolean;
    isAppClip: boolean;
    isValidated: boolean;
    name: string;
    shortVersion: string;
    version: string;
  }[];
  hasError: boolean;
};

export type DepartmentApps = {
  size: string;
  companyId: string;
  version: string;
  osType: string;
  icon: string;
  price: number;
  sellerName: string;
  currency: string;
  bundleId: string;
  primaryGenreName: string;
  appType: string;
  id: string;
  trackName: string;
  managed: boolean;
  silentInstall: boolean;
};

//enum
export enum EAccountStatus {
  ACTIVE = "ACTIVE",
  SUSPEND = "SUSPEND",
  STAGED = "STAGED",
}

export enum PasswordStatusEnum {
  SET = "SET",
  NOT_SET = "NOT_SET",
  TEMP = "TEMP",
  EXPIRED = "EXPIRED",
}

export enum EContractType {
  FULLTIME = "FULLTIME",
  PARTTIME = "PARTTIME",
  FIXED_TERM_CONTRACT = "FIXED_TERM_CONTRACT",
}

export enum EWorkType {
  REMOTE = "REMOTE",
  ON_SITE = "ON_SITE",
  HYBRID = "HYBRID",
}

export enum EDomainType {
  GSUIT = "GSUIT",
  MICROSOFT_ENTRA_ID = "MICROSOFT_ENTRA_ID",
  NA = "NA",
}

export enum EUserRole {
  OWNER = "OWNER",
  SUPER_ADMIN = "SUPER_ADMIN",
  IT_ADMIN = "IT_ADMIN",
  HR_ADMIN = "HR_ADMIN",
  TRIO_ADMIN = "TRIO_ADMIN",
  USER = "USER",
}

export enum EEmployeeOrderBy {
  mobilePhone = "mobilePhone",
  accountStatus = "accountStatus",
  employeeName = "employeeName",
}

export enum ESort {
  ASC = "ASC",
  DESC = "DESC",
}

export enum EDeviceOrderBy {
  NAME = "name",
  CREATED_AT = "createdAt",
}

export type TOnBoardBasicInfoPayLoad = {
  id: string;
  firstName: string;
  lastName: string;
  birthDate: string;
  email: string;
  password?: string;
  changePasswordStatus: boolean;
  homePhone: string;
  mobilePhone: string;
  phoneIso?: string;
  homePhoneIso?: string;
  personalEmail: string;
  homeCountry: string;
  homeState: string;
  homeCity: string;
  homeAddress?: string;
  homePostalCode?: string;
  // scheduleDate: Date;
  importedFrom: EDomainType;
  sendEmailAtMoment?: boolean;
  sameManagedAppleId: boolean;
};

export type TOnBoardJobInfo = {
  departmentId: string;
  jobTitleId: string;
  officeId: string;
  reporterId: string;
  contractType: EContractType | "";
  workType: EWorkType | "";
};

export type TOnBoardingGroupInfo = {
  departmentId: string;
};

export type GSuitEmployee = {
  users: {
    kind: string;
    id: string;
    etag: string;
    primaryEmail: string;
    name: {
      givenName: string;
      familyName: string;
      fullName: string;
    };
    isAdmin: boolean;
    isDelegatedAdmin: boolean;
    lastLoginTime: string;
    creationTime: string;
    agreedToTerms: boolean;
    suspended: boolean;
    archived: boolean;
    changePasswordAtNextLogin: boolean;
    ipWhitelisted: boolean;
    emails: [
      {
        address: string;
        primary: boolean;
      },
      {
        address: string;
      },
    ];
    languages: [
      {
        languageCode: string;
        preference: string;
      },
    ];
    nonEditableAliases: string[];
    customerId: string;
    orgUnitPath: string;
    isMailboxSetup: boolean;
    isEnrolledIn2Sv: boolean;
    isEnforcedIn2Sv: boolean;
    includeInGlobalAddressList: boolean;
    recoveryEmail: string;
  }[];
  nextPageToken: null;
};

export type IntegrationEmployee = {
  firstName: string;
  lastName: string;
  primaryEmail: string;
  isExist: boolean;
  givenName: string;
  surname: string;
  mail: string;
  userPrincipalName: string;
  avatar?: string;
  phoneNumber?: string;
  mobilePhone?: string;
};

export type ImportIntegrationEmployee = {
  firstName: string;
  email: string;
  lastName: string;
  type: string;
  password: string;
  userPrincipalName: string;
  mobilePhone?: string;
};

export type TEnrollMethod =
  | "BYOD"
  | "COD"
  | "TRIO_CONNECT"
  | "ANDROID_EMM_BYOD"
  | "ANDROID_EMM_COD";

export type TGetEmployeeListParams = {
  page: number;
  limit: number;
  orderBy?: EEmployeeOrderBy;
  orderDirection?: ESort;
  search?: string;
  departmentId?: string;
  statuses?: EAccountStatus[];
  enrollMethod?: TEnrollMethod;
  roleIds?: string[];
  itsMeFlag?: boolean;
  lastlogin?: string;
  role?: string[];
  createdAt?: string;
  mfaStatuses?: string[];
  organizationId?: string;
};

export type TEmployeeListFilterParams = TGetEmployeeListParams & {
  addingDrawerStatus?: AddingDrawerStatus;
};

export type AddingDrawerStatus =
  | "csv"
  | "googleWorkspace"
  | "office365"
  | "quickoffboard"
  | undefined;
